export default __webpack_public_path__ + "static/media/3278890a2fceeefbb5ce13060d18e402.png";